export const getPosthogCrossDomainParams = () => {
  const hashParams = new URLSearchParams(window.location.search);
  return {
    distinct_id: hashParams.get("posthog_distinct_id"),
    session_id: hashParams.get("posthog_session_id"),
  };
};
